import { GAME_SELECTION_NAVIGATION_ID } from '@/components/GameSelectionNavigation';
import { HEADER_ID } from '@/components/header';

export function getMenuTopOffset() {
  if (typeof window !== 'undefined') {
    const headerHeight = document.getElementById(HEADER_ID)?.offsetHeight ?? 0;
    const gameSelectionNavHeight =
      document.getElementById(GAME_SELECTION_NAVIGATION_ID)?.offsetHeight ?? 0;
    return headerHeight + gameSelectionNavHeight;
  }
  return 0;
}
